import {
  computed,
  ref,
} from 'vue';
import { useVModel } from '@vueuse/core';

/**
 * Composable para manejar la actualización de elementos
 *
 * @param {Object} props - Props del componente
 * @param {Function} emit - Función emit del componente
 * @param {string} eventName - Nombre del evento a emitir (por defecto 'update:modelValue')
 * @returns {Object} Objeto con las variables reactivas y funciones
 */
export function useElemento(props, emit, eventName = 'update:modelValue') {
  // Modelo local usando useVModel
  const localModel = useVModel(props, 'modelValue', emit);

  // Módulo actual

  // Modelo del collapse inicializado con el nombre del props
  const collapseModel = ref([props.name]);

  /**
   * Actualiza un elemento fusionando los datos con el modelo local
   *
   * @param {Object} elemento - Datos del elemento a fusionar
   */
  const updateModelo = (elemento) => {
    const updatedModel = { ...localModel.value, ...elemento };
    emit(eventName, updatedModel);
  };

  return {
    localModel,
    collapseModel,
    updateModelo,
  };
}
